// Ride state, starting the ride and the overview camera.
import * as THREE from 'three';
import { PI } from '../lib/math.js';
import { cam, controls } from '../core/scene.js';
import { setTilt } from '../core/post.js';
import { INTRO } from './intro.js';
import { tr } from '../ui/lang.js';
import { state } from '../core/state.js';
import { bBack, chapters, go, hint, introSub, speed } from '../dom.js';

export let START, S, R, keys, lookAt, wrapAngle, startRide, ovFly, toOverview, overviewFly;

export function buildRide() {
  startRide = function startRide() {
    if (state.mode === 'intro') lookAt.copy(INTRO.look);
    else lookAt.copy(controls.target);
    state.mode = 'ride';
    controls.enabled = false;
    controls.autoRotate = false;
    document.body.classList.add('riding');
    if (cam.aspect < 1) state.camDist = Math.min(state.camDist, 10); // portrait: closer, so the bike isn't a speck
    go.style.display = 'none';
    introSub.style.display = 'none';
    chapters.style.display = 'block';
    speed.style.display = 'block';
    setTilt(0.42, 1.3);
    bBack.style.display = 'none';
    ovFly.on = false;
    hint.textContent = tr('ride');
  };
  toOverview = function toOverview() {
    state.mode = 'overview';
    controls.enabled = true;
    document.body.classList.remove('riding');
    speed.style.display = 'none';
    setTilt(0.5, 3);
    bBack.style.display = '';
    bBack.textContent = tr('backToBike');
    ovFly.tgt.set(S.x * 0.35, 0, S.z * 0.35);
    ovFly.pos.set(ovFly.tgt.x + 18, 95, ovFly.tgt.z + 88);
    ovFly.on = true;
    controls.target.copy(lookAt);
    hint.textContent = tr('orbit');
  };
  overviewFly = function overviewFly(dt) {
    if (!ovFly.on) return;
    const k = 1 - Math.exp(-2.5 * dt);
    cam.position.lerp(ovFly.pos, k);
    controls.target.lerp(ovFly.tgt, k);
    if (cam.position.distanceTo(ovFly.pos) < 0.3) ovFly.on = false;
  };

  // ---------- riding ----------
  START = { x: 4.6, z: 49.4, y: 0.3, th: PI - 0.45 };
  S = { ...START, v: 0, steer: 0 };
  R = 0.5;
  keys = {};
  state.camHead = S.th;
  lookAt = new THREE.Vector3();
  wrapAngle = (a) => ((((a + PI) % (2 * PI)) + 2 * PI) % (2 * PI)) - PI;
  // overview: the camera glides up to a high three-quarter view of the whole island (centred between the bike and the
  // map centre) and hands over to orbit controls; a small pill brings you back to the bike (or press C again)
  ovFly = { on: false, pos: new THREE.Vector3(), tgt: new THREE.Vector3() };
  controls.addEventListener('start', () => {
    ovFly.on = false;
  }); // the visitor took over;
  bBack.onclick = () => {
    startRide();
    bBack.blur();
  };
  go.onclick = startRide;
}
